var _style, _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIndiIndiUnifiedDkLogo4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1000 1000",
    style: {
      enableBackground: "new 0 0 1000 1000"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{display:none;}\n\t.st1{fill:#FFFFFF;}\n\t.st2{fill:#EFBD1C;}\n\t.st3{fill:#FFCD34;}\n\t.st4{fill:#6B5D7B;}\n\t.st5{fill:#8D7F9E;}\n\t.st6{fill:#D55327;}\n\t.st7{fill:#F36F29;}\n\t.st8{fill:#038754;}\n\t.st9{fill:#2DB677;}\n\t.st10{fill:#ACACAC;}\n\t.st11{fill:#CCCCCB;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    className: "st0"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "R1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_x31_4"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M307,314.3c0,31.7-25.7,57.4-57.4,57.4c-10.4,0-20.1-2.8-28.5-7.5v-33.6c0-36.7,39.7-59.6,71.5-41.3l11.3,6.5 C305.9,301.6,307,307.8,307,314.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M303.9,295.8l-11.3-6.5c-31.8-18.4-71.5,4.6-71.5,41.3v33.6c-17.3-9.9-28.9-28.5-28.9-49.8 c0-31.7,25.7-57.4,57.4-57.4C274.8,256.9,296.2,273.2,303.9,295.8z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M427.6,555.1L647.5,682l49.4,28.5l44.6,25.8c24.9,14.3,54.5,3.5,66.3-19.5l-27.6-15.9l-55.6-32 c-2-0.7-4-1.6-6-2.7l-21.8-12.6L647.5,625l-145.5-84c-21.9-12.7-21.9-44.3,0-57L718.6,359c0.3-0.2,0.5-0.3,0.8-0.4l87.1-50.3 c-12.6-21.2-41-30.8-65-17L427.6,472.5C395.8,490.9,395.8,536.8,427.6,555.1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M610,472.9l-44.1-25.5l-0.6-0.3l-46.6-26.9l-2.7-1.6L316.6,303.5c0.8,4,1.2,8.2,1.2,12.4c0,16.5-6.2,31.5-16.4,43 c6.5-0.7,13.3,0.6,19.7,4.3l145.5,84l2.7,1.6l46.6,26.9l0.6,0.3l21.2,12.2c21.9,12.7,21.9,44.3,0,57l-14.2,8.2l45,26l41.3-23.9 C641.8,537.1,641.8,491.2,610,472.9z M474.1,581.9l-153,88.3c-21.9,12.7-49.4-3.2-49.4-28.5V391.6c0-5.5,1.3-10.6,3.6-15 c-6.9,2.5-14.4,3.9-22.2,3.9c-10.3,0-20-2.4-28.6-6.6v321.6c0,36.7,39.7,59.6,71.5,41.3l223.1-128.8L474.1,581.9z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIndiIndiUnifiedDkLogo4);
export default __webpack_public_path__ + "static/media/indi_indi-unified-dk-logo-4.2336ad0a5059186b30e08d813e6a2555.svg";
export { ForwardRef as ReactComponent };